import React from "react";
import style from "./style.module.scss";
import { formatCurrency } from "../../../../../../components/helper/helper";

const formatValue = (value) => {
  if (value === null || value === undefined) return "-";
  if (value === 0) return "";
  const formatted = formatCurrency(Math.abs(value));
  return value < 0 ? `-$${formatted}` : `$${formatted}`;
};

const formatRate = (value, suffix = "") => {
  if (value === null || value === undefined) return "-";
  if (value === 0) return "";
  return `${formatCurrency(value)}${suffix}`;
};

const Row = ({ data }) => {
  return (
    <tr className={style.table_row}>
      <td className={style.table_cell}>{data?.income_field_name}</td>
      <td className={style.table_cell}>{formatValue(data?.income_amount)}</td>
      <td className={style.table_cell}>{formatValue(data?.expense_amount)}</td>
      <td className={style.table_cell}>{formatRate(data?.times_rate)}</td>
      <td className={style.table_cell}>
        {formatRate(data?.calculation_amount)}
      </td>
      <td className={style.table_cell}>
        {formatValue(data?.calc_agent_expense)}
      </td>
      <td className={style.table_cell}>{formatValue(data?.line_amount)}</td>
      <td className={style.table_cell}>{formatRate(data?.split_rate, "%")}</td>
      <td
        className={`${style.table_cell} ${data?.split_amount < 0 ? style.negative : style.positive}`}
      >
        {formatValue(data?.split_amount)}
      </td>
    </tr>
  );
};

export default Row;
